import { Component, ElementRef, Input, ViewChild } from '@angular/core'
import { Feedback, QuestionAndAnswer } from '../../../../types'
import { ClipboardModule, ClipboardService } from 'ngx-clipboard'
import { CommonModule } from '@angular/common'
import { RatingDialogComponent } from '../rating-dialog/rating-dialog.component'
import { ResearchService } from '../../../../services/research.service'
import { TranslocoModule, TranslocoService } from '@jsverse/transloco'
import { ConfigService } from '../../../../services/config.service'
import { StatisticsService } from '../../../../services/statistics.service'

@Component({
   selector: 'app-action-bar',
   standalone: true,
   imports: [CommonModule, ClipboardModule, RatingDialogComponent, TranslocoModule],
   templateUrl: './action-bar.component.html',
   styles: ''
})
export class ActionBarComponent {

   @Input() qanda!: QuestionAndAnswer
   @ViewChild('ratingdialog', { static: false }) ratingDialog!: ElementRef

   currentReaction: Feedback['reaction']
   constructor(private clipboard: ClipboardService,
      private research: ResearchService,
      private translocoService: TranslocoService,
      private config: ConfigService,
      private stats: StatisticsService) {
   }

   rateThisAnswer(what: 'thumbs_up' | 'thumbs_down') {
      if (this.qanda.regenerating) {
         return
      }
      if (this.qanda.answer?.feedback) {
         if (this.qanda.answer?.feedback?.reaction === what) {
            // cancel/remove rating
            this.stats.sendEvent({ category: 'feedback-remove', action: what, label: 'answerId', value: this.qanda.answer.id, question: this.qanda.question })

            this.research.removeFeedback(this.qanda.answer.feedback)
            this.currentReaction = undefined
         }
         else {
            this.currentReaction = this.qanda.answer.feedback.reaction
            this.qanda.answer.feedback.reaction = what
         }
         // can maybe be done nicer, but this triggers change detection for feedback input
         this.qanda.answer.feedback = {...this.qanda.answer.feedback } as Feedback
      }
   }

   showCiteLink() {
      const translation = this.translocoService.translate('action.customlinkuri')
      if (translation === 'action.customlinkuri' || translation === '-' ) {
         return ''
      }
      return this.translocoService.getTranslation('action.customlinkuri')
   }

   copyText(button: HTMLButtonElement) {
      const abstractLabel = this.translocoService.translate('sources.selectedsource.abstract')
      const url = new URL(window.location.href)
      let renderedResults = ''
      // doing this in a for loop for readabality, doing it in a .map() got very crowded :)
      for (const [idx, source] of (this.qanda?.answer?.results ?? []).entries()) {
         let authors = ''
         if (source.authors) {
            authors = source.authors.join(', ')
         }
         if (source.year) {
            authors += `. ${source.year}.`
         }
         let description = ''
         if (source.description) {
            description = `\r\n${abstractLabel} ${source.description}`
         }
         //if(source.doi) {
         //   description += `\r\nDOI: ${source.doi}`
         //}
         if (source.deepLink) {
            description += `\r\n${url.origin + source.deepLink}`
         }

         renderedResults += `${idx + 1}. ${source.title}\r\n${authors}${description}\r\n\r\n`
      }

      let text = `${this.qanda.question}\r\n\r\n${this.qanda.answer?.answer}\r\n\r\n${renderedResults}`
      if(this.config.debug) {
         // add qanda id to text
         text += `\r\n\r\nQANDA ID: ${this.qanda?.answer?.id}`
      }
      this.stats.sendEvent({ category: 'answer', action: 'copy', label: 'answerId', value: this.qanda.answer?.id, question: this.qanda.question})
      this.clipboard.copy(text)
      button.focus()
   }

   async regenerateAnswer() {
      if (this.qanda.regenerating) {
         return
      }
      this.stats.sendEvent({ category: 'answer', action: 'regenerate', label: 'answerId', value: this.qanda.answer?.id, question: this.qanda.question})
      this.research.setAnswer(this.qanda.question, true)
   }
}
